import { FC } from "react";
import { useSelector } from "react-redux";

import { bandSettingsSelector } from "Bands/state";
import { IIconBandSetting } from "Bands/types";
import { copy } from "shared/assets";
import { Card } from "shared/components";
import { IDataKeys } from "shared/types";
import { EditTable } from "../components";

const settingsCopy = copy.bandSettings.memberSettings.memberCategories;

export const EditMemberCategories: FC = () => {
  const initialItems = useSelector(
    bandSettingsSelector<IIconBandSetting>(IDataKeys.memberCategories)
  );

  return (
    <Card title={settingsCopy.edit}>
      <EditTable
        name="bandMemberCategories"
        modalTitle={settingsCopy.modalTitle}
        modalMessage={settingsCopy.modalMessage}
        initialItems={initialItems}
        hasDragAndDrop={true}
        addCopy={settingsCopy.add}
        dataKey={IDataKeys.memberCategories}
      />
    </Card>
  );
};
